// src/services/priceRule.js
import apiClient from './api';

/**
 * Fetches CPQ Price Rules for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/price-rules
 */
export async function getCPQPriceRules(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/price-rules`);
  return response.data;
}
